import useCurrentRoute from './use-current-route';

function useRouteTitle() {
  const {route} = useCurrentRoute();
  return route?.title || 'Tenant Portal';
}

export default useRouteTitle;
